import React from 'react';

import { getHostnameWithProtocolFromRegex } from '../../../../utils/helpers';

type ExternalLinkItemProps = {
    href: string;
    target: '_self' | '_blank';
    provider: ProviderValuesType;
    config: ProviderConfigType;
};

export function ExternalLinkItem(props): React.ReactElement<ExternalLinkItemProps> {
    const { href, target, config } = props;
    // resolution of favicons on path2 are too low. That's why using local icons.
    // const [imageError, setImageError] = useState(false);
    const isHttpUrl = getHostnameWithProtocolFromRegex(href);

    return (
        <a
            className="wikiBox__links-item"
            rel="noreferrer noopener"
            target={target}
            href={isHttpUrl ? href : `https://${href}`}
        >
            <div className="wikiBox__links-logo">
                <img
                    className="wikiBox__links-img"
                    src={
                        config.imgSrc
                        // imageError
                        // 	? config.imgSrc
                        // 	: constants.paths.faviconPathV2 + href
                    }
                    alt={config.alt}
                    // onError={() => {
                    // 	setImageError(true);
                    // }}
                    width="32"
                    height="32"
                />
            </div>
            <span>{config.label}</span>
        </a>
    );
}
